import * as React from 'react';
import { DATA_HOOKS } from './dataHooks';

export const FileUploadVisual: React.FC<{
  clickPopup?: boolean;
  children?: React.ReactNode;
}> = ({ children, clickPopup }) => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  React.useEffect(() => {
    if (mounted && clickPopup) {
      (
        document.body.querySelector(
          `[data-hook="${DATA_HOOKS.popoverButton}"]`,
        ) as HTMLButtonElement | undefined
      )?.click();
    }
  }, [mounted]);
  return <div>{children}</div>;
};
